import { render, staticRenderFns } from "./SemiologiaUrologica.vue?vue&type=template&id=05d761ac"
import script from "./SemiologiaUrologica.vue?vue&type=script&lang=js"
export * from "./SemiologiaUrologica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports